import * as Sentry from '@sentry/angular';

/**
 * Basic Sentry handler with failed chunk detection and reload
 */
export class SentryErrorHandlerWithFailedChunkReload extends Sentry.SentryErrorHandler {
  private static readonly CHUNK_RELOAD_KEY = 'chunk-reload-attempted';

  public override handleError(error: unknown): void {
    const message = error instanceof Error ? error.message : String(error);

    // Detect failed chunks
    if (/Failed to fetch dynamically imported module/.test(message)) {
      // Load last time this happened from the session storage and don't reload if the last attempt was
      // within 10 seconds to prevent an endless loop in case there is an issue on the remote server,
      // causing additional load.
      const lastAttempt = Number(sessionStorage.getItem(SentryErrorHandlerWithFailedChunkReload.CHUNK_RELOAD_KEY));
      if (!lastAttempt || Date.now() - lastAttempt > 10_000) {
        sessionStorage.setItem(SentryErrorHandlerWithFailedChunkReload.CHUNK_RELOAD_KEY, String(Date.now()));
        Sentry.logger.error(message, error instanceof Error ? { ...error } : undefined);
        window.location.reload();
        return;
      }

      // Indicate this happened in the cooldown period
      Sentry.logger.error(message + ' (portal has not been reloaded to prevent server load)', error instanceof Error ? { ...error } : undefined);
    }

    // Regular Sentry handler
    super.handleError(error);
  }
}
